import React, { useState, useEffect } from "react";
import ScheduleAssessBoxHW from "./ScheduleAssessBoxHW";
import axios from "../../../../../axios";
import NoResponse from "../../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import moment from "moment";

const SchedAssePropsBoxHW = ({ filter }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [publishhw, setPublishHW] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const timeHelper = (a) => {
    const outputDateString = moment(a).format("DD/MM/YYYY");
    return outputDateString;
  };
  useEffect(() => {
    const getPublishedRes = async () => {
      try {
        let helper = [];
        let response = await axios.get(
          `/api/v1/homework/filterByTeacherId/${Teacher_Json}/scheduled?_page=1` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );

        if (response?.data?.data.length === 0) {
          helper = [];
          setPublishHW([]);
          setNoresponse(true);
        }
        response?.data?.data.forEach((obj) => {
          let res = {
            id: obj?.id,
            class_section: `${
              obj?.standard_id?.name + " " + obj?.section_id?.name
            }`,
            published_subject: `${obj?.subject_id.name}`,
            published_assessName: `${obj?.name}`,
            deadline_date: timeHelper(obj?.deadline),
            schedule_date: timeHelper(obj?.schedule_date),
          };
          helper.push(res);
          setPublishHW(helper);
        });
      } catch (e) {
        console.log(e);
      }
    };
    getPublishedRes();
  }, [filter]);
  return publishhw && publishhw.length > 0 ? (
    <div className="d-flex flex-wrap gap-3">
      {publishhw.map((obj) => (
        <ScheduleAssessBoxHW
          id={`${obj.id}`}
          Scheduled_class_section={`${obj.class_section}`}
          Scheduled_subject={`${obj.published_subject}`}
          Scheduled_assessName={`${obj.published_assessName}`}
          deadline_date={`${obj.deadline_date}`}
          schedule_date={`${obj.schedule_date}`}
        />
      ))}
    </div>
  ) : (
    <>
      <img
        className="publishAccessLoader"
        src="/gift/black loader.gif"
        alt=""
      />
      {noresponse && <NoResponse setNoresponse={setNoresponse} />}
    </>
  );
};

export default SchedAssePropsBoxHW;
